"use client";

export default function WeddingInfo() {
  return <section className="bg-background py-16 md:py-24 !bg-[url(https://vanessabrian.com/wp-content/uploads/2026/02/background-3.jpg)]">
      <div className="container mx-auto max-w-7xl px-4 md:px-8">
        <img src="https://vanessabrian.com/wp-content/uploads/2026/02/info-3.png" alt="Wedding photo" className="w-full h-auto rounded-lg shadow-medium" />
      </div>
    </section>;
}